import { SidebarItem } from '@backstage/core-components';
import SpeedIcon from '@material-ui/icons/Speed';

export const DELIVERY_METRICS_URL =
  'https://wts-paradigm.github.io/platform-delivery-metrics/';

export const DeliveryMetricsSidebarItem = () => (
  <SidebarItem
    icon={SpeedIcon}
    to={DELIVERY_METRICS_URL}
    text="Delivery Metrics"
    target="_blank"
    rel="noopener noreferrer"
  />
);
